// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"25b0c688","453":"e18097cc","750":"3db69e59","833":"e9144868"}[chunkId] + ".chunk.js";
};